angular.module('invoice')
    .controller('InvoiceCostController', function (data, $uibModalInstance, InvoiceService) {
        let zeros = {totalNet: 0, totalVat: 0, totalGross: 0}

        this.$onInit = () => {
            this.document = data.document
            this.total = data.document.pricing || zeros
            this.item = data.item
            this.calculatePercentage()
        }
        this.categoryChanged = () => {
            delete this.item.billingStartDate
            delete this.item.billingEndDate
        }
        this.onNetChanged = () => {
            this.calculatePercentage()
            this.calculateVat()
            this.calculateGross()
        }
        this.onVatChanged = () => {
            this.calculateGross()
        }
        this.onGrossChanged = () => {
        }
        this.onPercentageChanged = () => {
            this.calculateNet()
            this.calculateVat()
            this.calculateGross()
        }
        this.calculatePercentage = () => {
            this.percentage = InvoiceService.divide(this.item.price.totalNet * 100, this.total.totalNet) || 0
        }
        this.calculateNet = () => {
            this.item.price.totalNet = InvoiceService.multiply(this.percentage / 100, this.total.totalNet)
        }
        this.calculateVat = () => {
            this.item.price.totalVat = InvoiceService.multiply(this.percentage / 100, this.total.totalVat)
        }
        this.calculateGross = () => {
            this.item.price.totalGross = InvoiceService.add(this.item.price.totalNet, this.item.price.totalVat)
        }
        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => $uibModalInstance.close(this.item)
    })
